<!-- Account Vehicle Package Modal-->
<button type="button" class="btn btn-primary" id="openAccountPackages" [hidden]="true" data-toggle="modal"
  data-target="#accountPackages" data-backdrop="static" data-keyboard="false" data-dismiss="modal">Hidden
  Btn</button>

<div class="modal fade" id="accountPackages" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title">Account Packages</h5>
        <button id="closeAccountPackages" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" (click)="resetAccountPackages()">&times;</span>
        </button>
      </div>
      <form #accountPackagesForm="ngForm" novalidate (ngSubmit)="submitAccountPackages(accountPackagesForm)">
        <div class="modal-body">
          <div class="row">
            <div class="col-12 mb-3 table-responsive no-gutters">
              <table class="table tbl-scrollable">
                <thead class="thead-light">
                  <tr>
                    <th scope="col" width="22%" class="text-center">
                    </th>
                    <th scope="col" width="78%">Name</th>
                  </tr>
                </thead>
                <tbody *ngIf="pkgList && pkgList.length>0; else noPackages"
                  class="scroll-height-screenHeight hide-x-scroll" id="accordionAccountServicePackages">
                  <ng-container *ngFor="let package of pkgList; let i = index">
                    <tr [ngClass]="{'pointer collapsed':package.vehicleProfiles && package.vehicleProfiles.length > 0}" data-toggle="collapse" [attr.data-target]="'#account-service-packages-' + i"
                      aria-expanded="false" aria-controls="'udr-account-service-package-' + i">
                      <th scope="row" width="22%" class="text-center pr-0">
                        <div class="custom-control custom-checkbox">
                          <div (click)="$event.stopPropagation()">
                            <input type="checkbox" name="accountPackageCheckbox" class="custom-control-input" [checked]="package.isDefault"
                              (change)="onPackageSelectionChange($event.target.checked, package)" id="accountPackage_{{i}}">
                            <label class="custom-control-label" for="accountPackage_{{i}}"></label>
                          </div>
                        </div>
                      </th>
                      <td scope="row" width="78%">{{package.name}}</td>
                    </tr>
                    <tr *ngIf="package.vehicleProfiles" [attr.id]="'account-service-packages-' + i" class="collapse" data-parent="#accordionAccountServicePackages">
                      <div class="card">
                          <table class="table mb-0">
                          <tbody class="max-height-75">
                            <tr *ngFor="let profile of package.vehicleProfiles; let j = index">
                              <th scope="row" width="7%"></th>
                              <td width="15%">{{profile.brand}}</td>
                              <td width="33%">{{profile.model}}</td>
                              <td width="25%">{{profile.trimName}}</td>
                              <td width="20%">{{profile.year}}</td>
                            </tr>
                          </tbody>
                        </table>

                        <div class="row" *ngFor="let vehicleProfile of package.vehicleProfiles; let j = index">
                        </div>

                      </div>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
              <ng-template #valueNotAvailable>
                <span>-</span>
              </ng-template>
            </div>
            <!-- <div class="col-12 text-right">
              <span *ngIf="previousPage != null" class="pointer" (click)="getPreviousPage()">
                << Previous</span>
                  <span *ngIf="nextPage != null" class="pointer" (click)="getNextPage()">&nbsp;&nbsp;&nbsp;&nbsp;Next >>
                  </span>
            </div> -->
          </div>
          <ng-template #noPackages>
            <div class="row text-center my-5 text-muted no-gutters">
              <div class="col">
                <h3>No Package available</h3>
              </div>
            </div>
          </ng-template>
        </div>
        <div class="modal-footer">
          <i class="fas fa-arrow-left maroon pointer font20 mr-auto" (click)="backAccountPackages()"></i>
          <button type="button" class="btn btn-light btn-80" data-dismiss="modal"
            (click)="resetAccountPackages()">CANCEL</button>
          <button type="submit" class="btn btn-primary"
            [disabled]="!(pkgList && pkgList.length>0)">Submit</button>
        </div>
      </form>
    </div>
  </div>
</div>
